<template>
	<v-container>
		<v-row>
			<v-col
					v-if="$vuetify.breakpoint.mdAndUp"
					lg="4"
					md="4"
					xl="4"
			>
				<v-card
						:rounded="$vuetify.breakpoint.smAndDown ? '0' : 'lg'"
						class="mt-4"
				>
					<v-card-title class="pb-0">
						{{ $t("pages.notifications.notificationsManagement") }}
					</v-card-title>

					<loading-component
							:is-loading="getLoadingByKey(NOTIFICATION_TYPES_KEY)"
					>
						<error-component
								:errors="getErrorsByKey(NOTIFICATION_TYPES_KEY)"
								:has-error="hasErrorsByKey(NOTIFICATION_TYPES_KEY)"
								:reload="loadNotificationTypes"
						>
							<v-list expand>
								<v-list-item
										v-for="(type, i) in types"
										:key="`notification-type-${type.type}-${i}`"
										:to="{
											name: 'categorizedNotifications',
											params: { type: type.type ?? 'All' },
										}"
								>
									<v-list-item-content>
										<v-list-item-title>
											{{ $t(`pages.notifications.tabs.${type.title}.long`) }}
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</v-list>
						</error-component>
					</loading-component>
				</v-card>
			</v-col>
			<v-col
					class="px-sm-only-0 px-xs-0"
					lg="8"
					md="8"
					xl="8"
			>
				<loading-component
						v-if="$vuetify.breakpoint.smAndDown"
						:is-loading="getLoadingByKey(NOTIFICATION_TYPES_KEY)"
				>
					<error-component
							:errors="getErrorsByKey(NOTIFICATION_TYPES_KEY)"
							:has-error="hasErrorsByKey(NOTIFICATION_TYPES_KEY)"
							:reload="loadNotificationTypes"
					>
						<v-tabs
								class="mobile-tabs"
								grow
						>
							<v-tab
									v-for="(type, i) in types"
									:key="`notification-type-${type.type}-${i}`"
									:to="{
										name: 'categorizedNotifications',
										params: { type: type.type ?? 'All' },
									}"
									class="no-uppercase"
							>
								{{ $t(`pages.notifications.tabs.${type.title}.short`) }}
							</v-tab>
						</v-tabs>
					</error-component>
				</loading-component>

				<router-view
						:key="$route.fullPath"
						:types-map="typesMap"
						class="mt-4"
				/>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { handleGqlResponseBody } from "@/utils/apollo.util";
import { loadingByKeyLaterInitMixin } from "@/mixins/loading-by-key-later-init.mixin";
import { errorByKeyLaterInitMixin } from "@/mixins/error-by-key-later-init.mixin";
import { GET_USER_NOTIFICATION_TYPES_QUERY } from "@/graphql/queries/user/notification/get-user-notification-types.query";
import LoadingComponent from "@/components/common/LoadingComponent.vue";
import ErrorComponent from "@/components/common/ErrorComponent.vue";

const NOTIFICATION_TYPES_KEY = "notificationTypes";
export default {
  components: { ErrorComponent, LoadingComponent },
  mixins: [loadingByKeyLaterInitMixin, errorByKeyLaterInitMixin],
  data() {
    return {
      types: [],
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "getCurrentUser",
    }),
    NOTIFICATION_TYPES_KEY: () => NOTIFICATION_TYPES_KEY,
    typesMap() {
      return this.types.reduce((acc, curr) => {
        acc[curr.type ?? "All"] = curr;
        return acc;
      }, {});
    },
  },
  created() {
    this.initLoadingByKey(NOTIFICATION_TYPES_KEY);
    this.initErrorByKey(NOTIFICATION_TYPES_KEY);
  },
  async mounted() {
    await this.loadNotificationTypes();
  },
  methods: {
    async loadNotificationTypes() {
      this.setLoadingByKey(NOTIFICATION_TYPES_KEY, true);

      await this.$showGqlError(
        async () => {
          const { types } = await handleGqlResponseBody((apollo) => {
            return apollo.query({
              query: GET_USER_NOTIFICATION_TYPES_QUERY,
              fetchPolicy: "cache-first",
            });
          });

          this.types = types;

          this.setLoadingByKey(NOTIFICATION_TYPES_KEY, false);
          this.clearErrorsByKey(NOTIFICATION_TYPES_KEY);
        },
        (_, { handledErrors }) => {
          this.setLoadingByKey(NOTIFICATION_TYPES_KEY, false);
          this.setErrorsByKey(NOTIFICATION_TYPES_KEY, handledErrors);
        }
      );
    },
  },
};
</script>
